import makeStyles from "@mui/styles/makeStyles";
import { ChipProps } from "./Chip.types";

export const useStyles = makeStyles((theme) => ({
  root: {
    fontWeight: 600,
    fontSize: 10,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.grey[700],
    borderRadius: 9999,
    height: 20,
    padding: 0,
    marginRight: 5,
  },
  label: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  sizeSmall: {
    height: 16,
    fontSize: 8,
    lineHeight: "9px",
    "& .MuiChip-label": {
      paddingLeft: 8,
      paddingRight: 8,
    },
  },
  sizeTiny: {
    fontSize: 8,
    fontWeight: "normal",
    lineHeight: "8px",
  },
  colorPrimary: ({ tone }: ChipProps) => ({
    backgroundColor: theme.palette.primary[tone ? tone : "light"],
  }),
  colorRed: {
    backgroundColor: theme.palette.red.light,
  },
  colorfuchsia: {
    backgroundColor: theme.palette.fuchsia.light,
  },
  colorYellow: {
    backgroundColor: theme.palette.yellow.light,
  },
  colorBlue: {
    backgroundColor: theme.palette.blue.light,
  },
  colorGreen: {
    backgroundColor: theme.palette.green.light,
  },
  colorPurple: {
    backgroundColor: theme.palette.purple.main,
  },
  colorBlack: {
    backgroundColor: theme.palette.common.black,
  },
  colorGrey: {
    color: theme.palette.grey[900],
    backgroundColor: theme.palette.grey[100],
    "& .MuiChip-label": {
      fontWeight: 400,
    },
  },
  textColorPrimary: {
    color: theme.palette.primary.main,
  },
  textColorRed: {
    color: theme.palette.red.main,
  },
  textColorfuchsia: {
    color: theme.palette.fuchsia.main,
  },
  textColorYellow: {
    color: theme.palette.yellow.main,
  },
  textColorBlue: {
    color: theme.palette.blue.main,
  },
  textColorGreen: {
    color: theme.palette.green.main,
  },
  textColorPurple: {
    color: theme.palette.purple.main,
  },
  textColorBlack: {
    color: theme.palette.common.black,
  },
  textColorGrey: {
    color: theme.palette.grey[700],
  },
  icon: {
    width: 12,
    height: 12,
    color: theme.palette.grey[500],
  },
}));
